package puzzlekey

import kotlin.random.Random

/** The fallback secret (ADR-0006): 20 Crockford base32 symbols, 100 bits. */
class RecoveryCode private constructor(internal val symbols: String) {

    /** The form he keeps and sends her: `XXXX-XXXX-XXXX-XXXX-XXXX`. */
    val display: String get() = symbols.chunked(4).joinToString("-")

    override fun equals(other: Any?) = other is RecoveryCode && other.symbols == symbols
    override fun hashCode() = symbols.hashCode()
    override fun toString() = "RecoveryCode(****)"

    companion object {
        private const val ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"
        private const val LENGTH = 20

        fun random(random: Random): RecoveryCode =
            RecoveryCode(CharArray(LENGTH) { ALPHABET[random.nextInt(ALPHABET.length)] }.concatToString())

        /** Accepts what a person types: any case, dashes or spaces, and I/L for 1, O for 0. */
        fun parse(typed: String): RecoveryCode? {
            val symbols = typed.uppercase()
                .filterNot { it == '-' || it.isWhitespace() }
                .replace('I', '1').replace('L', '1').replace('O', '0')
            if (symbols.length != LENGTH || symbols.any { it !in ALPHABET }) return null
            return RecoveryCode(symbols)
        }
    }
}
